// 自动生成文件 切勿改动!

export const projectName = 'crm'
export const dvaNamespacePrefix = 'crm'
